// extracted by mini-css-extract-plugin
export default {"slider-indicator":"YYSpv"};